import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class ViewCampaignLeads extends Component {

    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({
                hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false,
                hideScriptIgnore: false, hideDeleteAllPopup: false, hideIncorrectPassword: false
            });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };
        this.IncorrectPassworddialogClose = () => {
            this.setState({ hideIncorrectPassword: false });
        };
        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchLeadDetails()
                this.setState({ disabled: false })
            }
        }];

        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchLeadDetails()
                this.dialogClose();
            }
        }];
        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchLeadDetails()
                this.dialogClose();
                this.setState({
                    disabled: false
                })
            }
        }];

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteLeadDetails(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];
        this.state = {
            data: [],
            editImageSrc: './assets/images/edit.svg',
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            contentEditable: "false",
            editedId: '-1',



        }
        this.editImageSrc = "./assets/images/edit2.png";
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";



    }
    componentDidMount() {
        var campaignLeadController = this;

        setTimeout(() => {
            campaignLeadController.fetchLeadDetails();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            window.location.href = '/sales-desk/projectmgmt/out-reach-campaign/manage-campaign';

        });
    }
    fetchLeadDetails = () => {

        var campaignLeadController = this;
        $.ajax({
            url: "/salesdesk-api/fetch-campaigns-leads",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem('currentProjectId'),
                campaignId: this.props.location.state.id
            },
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    campaignLeadController.state.data = res.result;
                    campaignLeadController.setState(campaignLeadController.state);
                } else {
                    campaignLeadController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }
        });
    }
    validateCells(value) {
        if ((value == "")) {
            this.notifyEmptyTagKeyFields();
            return false;
        }
        else {
            return true;
        }
    }
    notifyEmptyTagKeyFields() {
        toast(<b >Please change the tag field</b>, {
            position: "bottom-center",
            color: "#007aff"
        });
    }
    updateLeadApi(props, e) {
        props.original.name = document.getElementById("name" + props.index).innerText.trim();
        props.original.contactNumber = document.getElementById("contactNumber" + props.index).innerText.trim();
        props.original.email = document.getElementById("email" + props.index).innerText.trim();
        props.original.title = document.getElementById("title" + props.index).innerText.trim();
        props.original.organization = document.getElementById("organization" + props.index).innerText.trim();



        var validateResult = this.validateCells(props.original.code)
        if (validateResult == true) {


            var updatedData = {
                id: props.original.id,
                name: props.original.name,
                contactNumber: props.original.contactNumber,
                emailId: props.original.email,
                designation: props.original.designation,
                organization: props.original.organization
            };
            var updatedDataController = this
            $.ajax({
                url: "/salesdesk-api/update-campaigns-lead-details",
                async: false,
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',

                },
                data: JSON.stringify(updatedData),
                success: function (res) {
                    if (res.success === true) {
                        updatedDataController.state.editedId = "-1";
                        updatedDataController.notifyUpdate();
                        updatedDataController.fetchLeadDetails();
                    } else {
                        updatedDataController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/login";
                    }
                }


            })
        }
    }
    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Lead detail updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Lead detail deleted successfully</b>, {
            position: "top-center",
        });
    }

    makeCelledit(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }
    deleteLeadDetails = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
        } else {
            $.ajax({
                url: "/salesdesk-api/delete-campaigns-lead-detail/" + id,
                async: false,
                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDelete();
                        deleteRowViewController.splice(id, 1);
                    } else {
                        deleteRowViewController.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/sales-desk/login";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(id, 1);
        }
        deleteConstructorVariables.fetchLeadDetails();


    }
    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            contactNumber="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }
    goBackOfCampaignLeads = () => {
        this.props.history.push({
            pathname: "/projectmgmt/out-reach-campaign/manage-campaign",

        });
        // window.location.href = '/projectmgmt/out-reach-campaign/manage-campaign';

    }
    getFailedDeliveryReport = () => {
        var campaignLeadController = this;
        $.ajax({
            url: "/salesdesk-api/download-failed-delivery-report",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem('currentProjectId'),
                campaignId: this.props.location.state.id
            },
            headers: {

                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    const b64Data = res.result.data;
                    const blob = campaignLeadController.b64toBlob(b64Data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8', 512)
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = res.result.fileName;
                    document.body.appendChild(link);
                    link.click();
                } else {
                    campaignLeadController.notifyFailToCreate();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/sales-desk/login";
                }
            }
        });
    }

    b64toBlob = (b64Data, contentType, sliceSize) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    notifyFailToCreate() {
        toast(<b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>, {
            position: "top-center",
            color: "red"

        });
    }

    render() {

        const { data } = this.state
        const dataColumn = [
            {
                Header: <b>Name</b>,
                textAlign: 'screenLeft',
                accessor: 'name',
                sortable: false,
                headerStyle: { marginLeft: '10px' },
                Cell: props => {
                    return (
                        <div name="name">
                            <div className="textarea"
                                style={{
                                    background: 'white', height: '5%',
                                    resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                    border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                                }}
                                id={"name" + props.index}
                                class="form-control"
                                rows="1"
                                contentEditable={!((props.original.id == "") ? false :
                                    props.original.id != this.state.editedId) ? "plaintext-only" : false}
                            >
                                {props.original.name}
                            </div>
                        </div>
                    )
                },
            },

            {
                Header: () => <b>Email</b>,
                accessor: 'email',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="email">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"email" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.emailId}
                        </div>
                    </div>
                )
            }, {
                Header: () => <b>Phone Number</b>,
                accessor: 'contactNumber',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="contactNumber">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"contactNumber" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.contactNumber}
                        </div>
                    </div>
                )
            },
            {
                Header: () => <b>Title</b>,
                accessor: 'title',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="title">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"title" + props.index}
                            class="form-control"
                            rows="1"

                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.designation}
                        </div>
                    </div>
                )
            },
            {
                Header: () => <b>Organization</b>,
                accessor: 'organization',
                sortable: false,
                headerStyle: { marginLeft: '10px', },
                Cell: props => (
                    <div name="organization">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"organization" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={!((props.original.id == "") ? false :
                                props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        >
                            {props.original.organization}
                        </div>
                    </div>
                )
            },
            {
                Header: () => <b>Status</b>,
                accessor: 'status',
                sortable: false,
                width: 100,
                Cell: props => (
                    <div name="status">
                        <div className="textarea"
                            style={{
                                background: 'white', height: '5%',
                                resize: 'none', borderBottom: 'none', paddingLeft: '2px', paddingTop: '6px',
                                border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none'
                            }}
                            id={"status" + props.index}
                            class="form-control"
                            rows="1"
                            contentEditable={false}
                        >
                            {
                                props.original.status == 'NEW' ?
                                    <img src="assets/images/newMessage.png" style={{ paddingRight: '0px', height: '20px', width: '20px', marginLeft: '3vw' }} title="New" /> :
                                    props.original.status == 'DELIVERED' ?
                                        <img src="assets/images/done.svg" style={{ paddingRight: '0px', height: '20px', width: '20px', marginLeft: '3vw' }} title="Delivered" /> :
                                        <img src="assets/images/errorMessage.png" style={{ paddingRight: '0px', height: '20px', width: '20px', marginLeft: '3vw' }} title="Error" />
                            }


                        </div>
                    </div>
                )
            },
            {
                Header: <b>Action</b>,
                accessor: 'action',
                width: 200,
                Cell: props => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px' }} >
                            <img className="img-responsive"
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                src={(props.original.id == "") ? this.saveImageSrc : ((props.original.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.original.id == "") ? this.updateLeadApi(props, e) : (props.original.id == this.state.editedId) ?
                                        this.updateLeadApi(props, e) : this.makeCelledit(props, e);
                                }} />
                        </button>


                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                onClick={() => (props.original.id) === '' ?
                                    this.fetchLeadDetails() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index, propsId: props.original.id
                                    })} /></button>
                    </div>), width: 100
            },
        ]


        return (
            <div>
                <div style={{ background: "#F9F9FB" }}
                >
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    {/*links for css files used for popup */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="wrapper">
                        <div className="row" style={{ marginLeft: "2px" }}>
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackOfCampaignLeads}
                                />
                            </div>
                            <div className="col-sm-5" >
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '35px' }}>
                                    {this.props.location.state.name}
                                </h6>
                            </div>
                            <div className="col-sm-3" >
                                <button className="btn2 table-action-button "
                                    title="Download Failed Delivery Report"
                                    style={{ marginTop: '25px', height: "35px", marginLeft: "6vw" }}
                                    onClick={() => {
                                        this.getFailedDeliveryReport();
                                    }}
                                >Download Failed Delivery Report</button>
                            </div>



                        </div>

                        <div className="email">
                            <div className="container-fluid">
                                <div className="row" style={{ marginTop: '1%' }}>
                                    <div className="col-lg-12 ">
                                        <div className="card">
                                            <ReactTable
                                                data={data}
                                                columns={dataColumn}
                                                defaultPageSize={5}
                                                pageSizeOptions={[5, 10, 15]}
                                                onPageChange={this.onPageChange}
                                            // page={this.state.pageNum}
                                            />
                                        </div>
                                        <ToastContainer className="Toast-at-center" />


                                    </div>
                                </div>
                            </div>
                            {/*Dialog Component For Deletion Confirmation*/}
                            <DialogComponent width='400px' animationSettings={this.settings}
                                header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                                ref={dialog => this.dialogInstance = dialog}
                                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                    content="" />&nbsp;Do you want to delete the Lead detail?
                                Note: Press 'Yes' to delete or press 'No' to decline.
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</DialogComponent>
                        </div>
                    </div>
                </div>
            </div>

        )
    }


}

export default ViewCampaignLeads;


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/ViewCampaigns.js